module.exports = __webpack_public_path__ + "static/media/focusstandBackIllustration.fef42db6.jpg";